import type React from "react";

import { CHART_CONFIG } from "./constants";

export type RoundedBarProps = {
  bars: { dataKey: string }[];
  dataKey: string;
  fill: string;
  height: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
  width: number;
  x: number;
  y: number;
};

export const RoundedBar: React.FC<RoundedBarProps> = ({ bars, dataKey, fill, height, payload, width, x, y }) => {
  const isTopBar = () => {
    const barsReversed = [...bars].reverse();
    const topBar = barsReversed.find(bar => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const value = payload[bar.dataKey as keyof any];
      return value !== undefined && parseFloat(value as string) > 0;
    });

    return dataKey === topBar?.dataKey;
  };

  const radius = isTopBar() ? Math.min(CHART_CONFIG.BORDER_RADIUS, height, width / 2) : 0;

  return (
    <g>
      <path
        d={`
          M ${x},${y + radius}
          Q ${x},${y} ${x + radius},${y}
          L ${x + width - radius},${y}
          Q ${x + width},${y} ${x + width},${y + radius}
          L ${x + width},${y + height}
          L ${x},${y + height}
          Z
        `}
        fill={fill}
      />
    </g>
  );
};
